<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title fw-semibold mb-4">Pemeriksaan Responden</h5>
            <hr class="border-0 pt-1 rounded bg-primary my-4">

            <form @submit.prevent="onSubmit">
              <div class="row g-4">
                <div class="col-lg-3">
                  <div class="mb-4" v-if="userList && userList.Records">
                    <label for class="form-label">Pilih Responden *</label>
                    <v-select
                      v-model="userID"
                      @input="setPregancy()"
                      :placeholder="`-- Pilih --`"
                      label="label"
                      :options="userList.Records.map(elem => ({label: `${elem.user_profile.fullname} - ${elem.user_profile.nik}`, code: elem.id}))"
                    />
                    <!-- <select
                      v-model="form.userId"
                      @change="setPregancy()"
                      class="form-select"
                      required
                    >
                      <option
                        v-for="item in userList.Records"
                        :value="item.id"
                        :key="`ul${item.id}`"
                      >{{item.user_profile.fullname}} - {{item.user_profile.nik || item.user_profile.telp}}</option>
                    </select>-->
                  </div>
                  <div class="mb-4">
                    <label for="exampleDataList" class="form-label">Jenis Pemeriksaan *</label>
                    <div v-for="item in items" :key="`cb-${item}`" class="form-check mb-2">
                      <input
                        :value="item"
                        v-model="type_examination"
                        type="checkbox"
                        class="form-check-input"
                        :id="item"
                        autocomplete="off"
                      >
                      <label class="form-check-label" :for="item">{{item}}</label>
                    </div>
                  </div>

                  <div class="mb-4">
                    <label for class="form-label">Tujuan Pemeriksaan *</label>
                    <div
                      v-for="item in ['Screening', 'Kontrol Rutin', 'Follow-up Penyakit Tertentu', 'Imunisasi & Suplementasi', 'Lainnya'] "
                      :key="`jp${item}`"
                      class="form-check mb-2"
                    >
                      <input
                        :value="item"
                        v-model="form.examination_purpose"
                        type="checkbox"
                        class="form-check-input"
                        :id="item"
                        autocomplete="off"
                      >
                      <label class="form-check-label" :for="item">{{item}}</label>
                    </div>
                  </div>
                </div>

                <div class="col-lg-9">
                  <!-- ✅ Tab List -->
                  <ul class="nav nav-tabs">
                    <li class="nav-item" v-for="(tab, idx) in type_examination" :key="`tab-${tab}`">
                      <a
                        href="#"
                        class="nav-link"
                        :class="{ active: activeTab === tab }"
                        @click.prevent="activeTab = tab"
                      >{{ tab }}</a>
                    </li>
                  </ul>

                  <!-- ✅ Tab Content -->
                  <div class="tab-content p-3 border border-top-0">
                    <div
                      v-for="tab in type_examination"
                      :key="`content-${tab}`"
                      class="tab-pane"
                      :class="{ active: activeTab === tab }"
                    >
                      <template v-if="tab === 'Kesehatan Umum'">
                        <!-- Control Section Start -->
                        <label for class="form-label text-uppercase mb-4">Kesehatan Umum</label>
                        <div v-for="(items, group) in examGroupList" :key="group" class="mb-4">
                          <div class="fs-4 mb-1 text-info fw-medium">{{group}}</div>
                          <div class="table-responsive">
                            <table class="table table-striped align-middle">
                              <thead>
                                <tr>
                                  <th scope="col">#</th>
                                  <th class="w-25" scope="col">Pemeriksaan</th>
                                  <th scope="col">Hasil</th>
                                  <th scope="col">Referensi</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(req, idx) in items" :key="req.id">
                                  <th scope="row">{{ idx + 1 }}</th>
                                  <td class="fw-bold">{{ req.examination_name }}</td>
                                  <td class="fw-bold text-nowrap">
                                    <div class="mb-2">
                                      <input
                                        v-model="req.result"
                                        type="text"
                                        class="form-control form-control-sm bg-light fw-bold mx-auto"
                                        placeholder="Hasil..."
                                        autocomplete="off"
                                      >
                                      <!-- required -->
                                    </div>
                                  </td>
                                  <td>
                                    <ul class="nav small flex-column">
                                      <li>
                                        <b>Unit :</b>
                                        {{req.unit}}
                                      </li>
                                      <li>
                                        <b>Rujukan :</b>
                                        {{req.reverence_value}}
                                      </li>
                                    </ul>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div>
                          <textarea
                            v-model="form.remark"
                            class="form-control"
                            placeholder="Keluhan..."
                            rows="3"
                            required
                          ></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary mt-4">Simpan</button>
                        <!-- Control Section End -->
                      </template>
                      <template v-else-if="tab === 'Kontrol Kehamilan'">
                        <!-- Control Section Start -->
                        <label for class="form-label text-uppercase mb-4">Kontrol Kehamilan</label>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Profil Kehamilan *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <select
                              v-model="form2.pregnancyId"
                              @change="setHPL()"
                              class="form-select"
                              autocomplete="off"
                              required
                            >
                              <option value disabled hidden>--- Pilih ---</option>
                              <option
                                v-for="item in pregnancyList"
                                :value="item.id"
                                :key="`pl${item.id}`"
                              >{{item.profile_kehamilan}}</option>
                            </select>
                          </div>
                        </div>

                        <div class="mb-3">
                          <hr>
                          <div class="fs-4 mb-3 text-info fw-medium">Umum</div>

                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Tinggi Badan Ibu</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <input
                                type="text"
                                v-model="form2.height"
                                class="form-control"
                                placeholder="Tinggi Badan Ibu..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Berat Badan Ibu</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <input
                                type="text"
                                v-model="form2.weight"
                                class="form-control"
                                placeholder="Berat Badan Ibu..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Emosional Stabil</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form2.stable_affect"
                                  class="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  value="Ya"
                                  id="Ya"
                                  autocomplete="off"
                                  checked
                                >
                                <label class="form-check-label" for="Ya">Ya</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form2.stable_affect"
                                  class="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  value="Tidak"
                                  id="Tidak"
                                  autocomplete="off"
                                >
                                <label class="form-check-label" for="Tidak">Tidak</label>
                              </div>
                            </div>
                          </div>
                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Keadaan Umum</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form2.general_condition"
                                  class="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions2"
                                  value="Composmentis"
                                  id="Composmentis"
                                  autocomplete="off"
                                >
                                <label class="form-check-label" for="Composmentis">Composmentis</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form2.general_condition"
                                  class="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions2"
                                  value="Somnolent"
                                  id="Somnolent"
                                  autocomplete="off"
                                >
                                <label class="form-check-label" for="Somnolent">Somnolent</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form2.general_condition"
                                  class="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  value="Apatis"
                                  id="Apatis"
                                  autocomplete="off"
                                >
                                <label class="form-check-label" for="Apatis">Apatis</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="mb-3">
                          <hr>
                          <div class="fs-4 mb-3 text-info fw-medium">Tanda-Tanda Vital</div>

                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Tekanan Darah Ibu</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <input
                                type="text"
                                v-model="form2.blood_preasure"
                                class="form-control"
                                placeholder="Tekanan Darah Ibu..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Nadi</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <input
                                type="text"
                                v-model="form2.pulse_rate"
                                class="form-control"
                                placeholder="Nadi..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Suhu Badan</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <input
                                type="text"
                                v-model="form2.body_temperature"
                                class="form-control"
                                placeholder="Suhu Badan..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Pernafasan</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <input
                                type="text"
                                v-model="form2.respiratory_rate"
                                class="form-control"
                                placeholder="Pernafasan..."
                                autocomplete="off"
                              >
                            </div>
                          </div>
                        </div>

                        <div class="mb-3">
                          <hr>
                          <div class="fs-4 mb-3 text-info fw-medium">Extermitas</div>

                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Oedema</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form2.oedema"
                                  class="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions3"
                                  value="Ya"
                                  id="oya"
                                  autocomplete="off"
                                  checked
                                >
                                <label class="form-check-label" for="oya">Ya</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form2.oedema"
                                  class="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions3"
                                  value="Tidak"
                                  id="oTidak"
                                  autocomplete="off"
                                >
                                <label class="form-check-label" for="oTidak">Tidak</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="mb-3">
                          <hr>
                          <div class="fs-4 mb-3 text-info fw-medium">Laboratorium</div>

                          <div class="mb-3">
                            <label for class="col-form-label">Pemeriksaan Darah Rutin</label>
                            <div class="d-flex gap-2">
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">Hemoglobin</span>
                                <input
                                  type="text"
                                  v-model="form2.hemoglobin"
                                  class="form-control"
                                  placeholder="Hemoglobin..."
                                  autocomplete="off"
                                >
                              </div>
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">Trombosit</span>
                                <input
                                  type="text"
                                  v-model="form2.trombosit"
                                  class="form-control"
                                  placeholder="Trombosit..."
                                  autocomplete="off"
                                >
                              </div>
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">Leukosit</span>
                                <input
                                  type="text"
                                  v-model="form2.leukosit"
                                  class="form-control"
                                  placeholder="Leukosit..."
                                  autocomplete="off"
                                >
                              </div>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for class="col-form-label">Pemeriksaan Triple Eleminasi</label>
                            <div class="d-flex gap-2">
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">HIV</span>
                                <input
                                  type="text"
                                  v-model="form2.hiv"
                                  class="form-control"
                                  placeholder="HIV..."
                                  autocomplete="off"
                                >
                              </div>
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">Sifilis</span>
                                <input
                                  type="text"
                                  v-model="form2.sifilis"
                                  class="form-control"
                                  placeholder="Sifilis..."
                                  autocomplete="off"
                                >
                              </div>
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">HBSAG</span>
                                <input
                                  type="text"
                                  v-model="form2.hbsag"
                                  class="form-control"
                                  placeholder="HBSAG..."
                                  autocomplete="off"
                                >
                              </div>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for class="col-form-label">Pemeriksaan Gula Darah</label>
                            <div class="d-flex gap-2">
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">Sewaktu</span>
                                <input
                                  type="text"
                                  v-model="form2.random_blood_glucose"
                                  class="form-control"
                                  placeholder="Sewaktu..."
                                  autocomplete="off"
                                >
                              </div>
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">Puasa</span>
                                <input
                                  type="text"
                                  v-model="form2.fasting_blood_glucose"
                                  class="form-control"
                                  placeholder="Puasa..."
                                  autocomplete="off"
                                >
                              </div>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for class="col-form-label">Pemeriksaan Urin</label>
                            <div class="d-flex gap-2">
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">Protein</span>
                                <input
                                  type="text"
                                  v-model="form2.urine_protein"
                                  class="form-control"
                                  placeholder="Protein..."
                                  autocomplete="off"
                                >
                              </div>
                              <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">Warna</span>
                                <input
                                  type="text"
                                  v-model="form2.urine_color"
                                  class="form-control"
                                  placeholder="Warna..."
                                  autocomplete="off"
                                >
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr class="pt-1 border-0 rounded bg-dark my-4">

                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">HPHT</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              v-model="hpht"
                              type="date"
                              class="form-control"
                              placeholder="HPHT..."
                              autocomplete="off"
                              disabled
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">HPL</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              v-model="hpl"
                              type="date"
                              class="form-control"
                              placeholder="HPL..."
                              autocomplete="off"
                              disabled
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Usia Kehamilan</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              v-model="form2.pregnancy_age"
                              type="text"
                              class="form-control"
                              value
                              placeholder="Usia Kehamilan..."
                              autocomplete="off"
                              disabled
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Presentasi Janin</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <select
                              v-model="form2.fetal_presentation"
                              class="form-select"
                              autocomplete="off"
                            >
                              <option value disabled hidden>--- Pilih ---</option>
                              <option
                                value="Kepala Di Bawah (Cephalic / Vertex Presentation)"
                              >Kepala Di Bawah (Cephalic / Vertex Presentation)</option>
                              <option
                                value="Lintang (Transverse Lie) - Janin melintang, bahu menghadap jalan lahir"
                              >Lintang (Transverse Lie) - Janin melintang, bahu menghadap jalan lahir</option>
                              <option
                                value="Oblique Lie - Janin miring / diagonal"
                              >Oblique Lie - Janin miring / diagonal</option>
                              <option
                                value="Sungsang (Breech Presentation) - Bokong atau kaki di bawah"
                              >Sungsang (Breech Presentation) - Bokong atau kaki di bawah</option>
                              <option
                                value="Sungsang (Breech Frank) - Pantat di bawah, kaki lurus ke atas"
                              >Sungsang (Breech Frank) - Pantat di bawah, kaki lurus ke atas</option>
                              <option
                                value="Sungsang (Breech Complete) - Pantat di bawah, kaki terlipat"
                              >Sungsang (Breech Complete) - Pantat di bawah, kaki terlipat</option>
                              <option
                                value="Sungsang (Breech Footling) - Kaki di bawah"
                              >Sungsang (Breech Footling) - Kaki di bawah</option>
                              <option
                                value="Tidak Dapat Dinilai - Posisi tidak jelas"
                              >Tidak Dapat Dinilai - Posisi tidak jelas</option>
                            </select>
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Denyut Jantung Janin</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="text"
                              v-model="form2.fetal_heart_rate"
                              class="form-control"
                              placeholder="Denyut Jantung Janin..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Posisi Plasenta</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <select
                              v-model="form2.placenta_position"
                              class="form-select"
                              autocomplete="off"
                            >
                              <option value disabled hidden>--- Pilih ---</option>
                              <option
                                value="Anterior (Di dinding depan rahim)"
                              >Anterior (Di dinding depan rahim)</option>
                              <option
                                value="Posterior (Di dinding belakang rahim)"
                              >Posterior (Di dinding belakang rahim)</option>
                              <option value="Lateral Kanan">Lateral Kanan</option>
                              <option value="Lateral Kiri">Lateral Kiri</option>
                              <option value="Fundus (Di puncak rahim)">Fundus (Di puncak rahim)</option>
                              <option
                                value="Low-lying / Plasenta Letak Rendah"
                              >Low-lying / Plasenta Letak Rendah</option>
                              <option
                                value="Previa Totalis (Menutupi seluruh jalan lahir)"
                              >Previa Totalis (Menutupi seluruh jalan lahir)</option>
                              <option
                                value="Previa Partialis (Menutupi sebagian jalan lahir)"
                              >Previa Partialis (Menutupi sebagian jalan lahir)</option>
                              <option
                                value="Previa Marginalis (Hanya tepi plasenta yang mengenai jalan lahir)"
                              >Previa Marginalis (Hanya tepi plasenta yang mengenai jalan lahir)</option>
                            </select>
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Cairan Ketuban</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <select
                              v-model="form2.amniotic_fluid"
                              class="form-select"
                              autocomplete="off"
                            >
                              <option value disabled hidden>--- Pilih ---</option>
                              <option value="Normal">Normal</option>
                              <option value="Sedikit (Oligohidramnion)">Sedikit (Oligohidramnion)</option>
                              <option value="Banyak (Polihidramnion)">Banyak (Polihidramnion)</option>
                              <option value="Lainnya">Lainnya</option>
                            </select>
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">BB Janin (Estimasi)</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="text"
                              v-model="form2.estimated_fetal_weight"
                              class="form-control"
                              placeholder="BB Janin..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Tafsiran Fetus Uteri (TFU)</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              v-model="form2.tfu"
                              type="text"
                              class="form-control"
                              placeholder="Tafsiran Fetus Uteri..."
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Jenis Kelamin</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.fetal_gender"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions4"
                                id="inlineRadio1"
                                value="Laki-laki"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="inlineRadio1">Laki-laki</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form2.fetal_gender"
                                class="form-check-input"
                                type="radio"
                                name="inlineRadioOptions4"
                                id="inlineRadio2"
                                value="Perempuan"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="inlineRadio2">Perempuan</label>
                            </div>
                          </div>
                        </div>

                        <hr>

                        <div>
                          <textarea
                            v-model="form2.remark"
                            class="form-control"
                            placeholder="Keluhan..."
                            rows="3"
                            required
                          ></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary mt-4">Simpan</button>
                        <!-- Control Section End -->
                      </template>
                      <template v-else-if="tab === 'Persalinan'">
                        <!-- Control Section Start -->
                        <label for class="form-label text-uppercase mb-4">Persalinan</label>
                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Profil Kehamilan *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <select
                              v-model="form2.pregnancyId"
                              @change="setHPL()"
                              class="form-select"
                              autocomplete="off"
                              required
                            >
                              <option value disabled hidden>--- Pilih ---</option>
                              <option
                                v-for="item in pregnancyList"
                                :value="item.id"
                                :key="`per${item.id}`"
                              >{{item.profile_kehamilan}}</option>
                            </select>
                          </div>
                        </div>

                        <hr>

                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Waktu Kedatangan *</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <input
                              type="datetime-local"
                              v-model="form4.created_date"
                              class="form-control bg-white"
                              autocomplete="off"
                            >
                          </div>
                        </div>
                        <div class="mb-3">
                          <textarea
                            v-model="form4.remark"
                            class="form-control"
                            placeholder="Catatan Medis *..."
                            rows="3"
                            required
                          ></textarea>
                        </div>

                        <div class="row g-0 g-sm-3 align-items-center mb-3">
                          <div class="col-sm-4 col-md-3">
                            <label for class="col-form-label">Sudah Persalinan?</label>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form4.delivery_status"
                                class="form-check-input"
                                type="radio"
                                value="1"
                                name="finished_delivery"
                                id="inlineRadio555"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="inlineRadio555">Sudah</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input
                                v-model="form4.delivery_status"
                                class="form-check-input"
                                type="radio"
                                value="0"
                                name="finished_delivery"
                                id="inlineRadio666"
                                autocomplete="off"
                              >
                              <label class="form-check-label" for="inlineRadio666">Belum</label>
                            </div>

                            <div
                              v-if="form4.delivery_status == 1"
                              class="p-4 rounded bg-light mt-3"
                            >
                              <div class="row g-0 g-lg-3 align-items-center mb-3">
                                <div class="col-md-5 col-xl-4 col-xxl-3">
                                  <label for class="col-form-label">Waktu Persalinan *</label>
                                </div>
                                <div class="col-md-7 col-xl-8 col-xxl-9">
                                  <input
                                    type="datetime-local"
                                    v-model="form4.delivery_date"
                                    class="form-control bg-white"
                                    autocomplete="off"
                                  >
                                </div>
                              </div>
                              <div>
                                <textarea
                                  v-model="form4.delivery_remark"
                                  class="form-control bg-white"
                                  placeholder="Catatan Medis *..."
                                  rows="3"
                                  required
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button type="submit" class="btn btn-primary mt-4">Simpan</button>
                        <!-- Control Section End -->
                      </template>
                      <template v-else-if="tab === 'Postpartum'">
                        <label for class="form-label text-uppercase mb-4">Postpartum</label>
                        <div class="rounded">
                          <div class="row g-0 g-sm-3 align-items-center mb-3">
                            <div class="col-sm-4 col-md-3">
                              <label for class="col-form-label">Profil Kehamilan *</label>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <select
                                v-model="form2.pregnancyId"
                                @change="setHPL()"
                                class="form-select"
                                autocomplete="off"
                                required
                              >
                                <option value disabled hidden>--- Pilih ---</option>
                                <option
                                  v-for="item in pregnancyList"
                                  :value="item.id"
                                  :key="`po${item.id}`"
                                >{{item.profile_kehamilan}}</option>
                              </select>
                            </div>
                          </div>
                          <hr>

                          <div class="row g-0 g-lg-3 align-items-center mb-3">
                            <div class="col-lg-4">
                              <label for class="col-form-label">Waktu Kelahiran *</label>
                            </div>
                            <div class="col-lg-8">
                              <input
                                type="datetime-local"
                                v-model="form3.delivery_date"
                                class="form-control bg-white"
                                autocomplete="off"
                                required
                              >
                            </div>
                          </div>
                          <div class="row g-0 g-lg-3 align-items-center mb-3">
                            <div class="col-lg-4">
                              <label for class="col-form-label">Jenis Persalinan *</label>
                            </div>
                            <div class="col-lg-8">
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form3.delivery_type"
                                  value="Normal"
                                  class="form-check-input"
                                  type="radio"
                                  name="delivery_type"
                                  id="inlineRadio111"
                                  autocomplete="off"
                                  required
                                >
                                <label class="form-check-label" for="inlineRadio111">Normal</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form3.delivery_type"
                                  value="Cesarean"
                                  class="form-check-input"
                                  type="radio"
                                  name="delivery_type"
                                  id="inlineRadio222"
                                  autocomplete="off"
                                >
                                <label class="form-check-label" for="inlineRadio222">Cesarean</label>
                              </div>
                            </div>
                          </div>
                          <div class="row g-0 g-lg-3 align-items-center mb-3">
                            <div class="col-lg-4">
                              <label for class="col-form-label">Kondisi Ibu *</label>
                            </div>
                            <div class="col-lg-8">
                              <input
                                v-model="form3.maternal_condition"
                                type="text"
                                class="form-control bg-white"
                                placeholder="Kondisi Ibu..."
                                autocomplete="off"
                                required
                              >
                            </div>
                          </div>
                          <div class="row g-0 g-lg-3 align-items-center mb-3">
                            <div class="col-lg-4">
                              <label for class="col-form-label">Kondisi Bayi *</label>
                            </div>
                            <div class="col-lg-8">
                              <input
                                v-model="form3.fetal_condition"
                                type="text"
                                class="form-control bg-white"
                                placeholder="Kondisi Bayi..."
                                autocomplete="off"
                                required
                              >
                            </div>
                          </div>
                          <div class="row g-0 g-lg-3 align-items-center mb-3">
                            <div class="col-lg-4">
                              <label for class="col-form-label">Menyusui *</label>
                            </div>
                            <div class="col-lg-8">
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form3.breeding"
                                  value="1"
                                  class="form-check-input"
                                  type="radio"
                                  name="breeding"
                                  id="inlineRadio1111"
                                  autocomplete="off"
                                  required
                                >
                                <label class="form-check-label" for="inlineRadio1111">Ya</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input
                                  v-model="form3.breeding"
                                  value="0"
                                  class="form-check-input"
                                  type="radio"
                                  name="breeding"
                                  id="inlineRadio2221"
                                  autocomplete="off"
                                >
                                <label class="form-check-label" for="inlineRadio2221">Tidak</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button type="submit" class="btn btn-primary mt-4">Simpan</button>
                      </template>
                    </div>
                  </div>

                  <div class="tab-content" id="pills-tabContent">
                    <div
                      v-if="type_examination.includes('Kesehatan Umum')"
                      class="tab-pane fade show active"
                      id="pills-0"
                      role="tabpanel"
                      aria-labelledby="pills-0-tab"
                      tabindex="0"
                    ></div>

                    <div
                      v-if="type_examination.includes('Kontrol Kehamilan')"
                      class="tab-pane fade"
                      id="pills-1"
                      role="tabpanel"
                      aria-labelledby="pills-1-tab"
                      tabindex="0"
                    ></div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import _ from 'lodash'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			userID: '',
			items: ['Kesehatan Umum', 'Kontrol Kehamilan', 'Persalinan', 'Postpartum'],
			type_examination: [], // hasil checkbox
			activeTab: null, // tab aktif

			token: localStorage.getItem('token'),
			form: {
				userId: '',
				examination_date: new Date().toISOString(),
				examination_purpose: [],
				records: [
					{
						examination_name: '',
						unit: '',
						reference_value: '',
						description: '',
						result: '',
						remark: '',
						diagnoses: '',
						treatment: '',
						examination_purpose: ''
					}
				]
			},
			hpht: '',
			hpl: '',
			form2: {
				pregnancyId: '',
				control_date: new Date().toISOString(),
				pregnancy_age: '',
				blood_preasure: '',
				remark: '',
				statusId: '7',
				fetal_presentation: '',
				fetal_heart_rate: '',
				placenta_position: '',
				amniotic_fluid: '',
				estimated_fetal_weight: '',
				fetal_gender: '',
				examination_purpose: '',
				diagnoses: '',
				treatment: '',
				tfu: ''
			},
			form3: {
				//Postpartum
				delivery_date: '',
				delivery_type: '', //Normal
				maternal_condition: '',
				fetal_condition: '',
				breeding: 1,
				statusId: 12
			},
			form4: {
				//Persalinan
				pregnancyId: '',
				created_date: '',
				remark: '',
				delivery_status: 0,
				delivery_date: '',
				delivery_remark: '',
				statusId: 7
			},
			file: null,
			preview: '',
			title: 'Tambah',
			button: 'Simpan',
			url2: 'user_spesialized/',
			method: 'post'
			// statusSubmitForm: ''
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		this.$store.dispatch('location/getData', {
			url: `medical_examination`,
			params: {
				offset: 0,
				limit: 10000,
				order: 'desc'
			}
		})

		this.$store.dispatch('location/getDataThird', {
			url: `users`,
			params: {
				type: 'patient',
				offset: 0,
				limit: 10000,
				order: 'desc'
			}
		})
	},
	mounted() {
		this.form.userId = this.userId || ''
	},
	computed: {
		...mapGetters({
			pregnancyList: 'location/getDataPayload',
			userList: 'location/getDataThird',
			examList: 'location/getDCLocation'
		}),
		examGroupList: {
			// getter
			get() {
				return _.groupBy(this.examList, 'group') || ''
			}
		},
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		},
		type: {
			// getter
			get() {
				return this.$route.query.type || 'admin'
			}
		}
	},
	watch: {
		// otomatis set activeTab ke tab pertama jika belum ada
		type_examination(val) {
			if (val.length > 0 && !this.activeTab) {
				this.activeTab = val[0]
			}
			if (val.length === 0) {
				this.activeTab = null
			}
		}
	},
	methods: {
		getCity() {
			this.$store.dispatch('location/getDataPayload2', {
				url: `datasheet/cities/${this.form.province}`
			})
		},
		onSubmit() {
			// console.log('this.form kesehatan==>', this.form)
			// console.log('this.form2 kehamilan==>', this.form2)
			// return
			if (this.type_examination.length < 1 || this.form.examination_purpose.length < 1) {
				alert('Minimal pilih 1 jenis dan tujuan pemeriksaan')
				return
			}

			if (this.type_examination.includes('Kontrol Kehamilan')) {
				this.form2.examination_purpose = this.form.examination_purpose.join(', ')
				this.$store
					.dispatch('location/createNewRecord', {
						data: this.form2,
						url: 'user_pregnancies_data/' + this.form2.pregnancyId,
						method: this.method
					})
					.then((res) => {
						console.log('log dispatch dari file .vue ==>', res)
						let toast = this.$toasted.show(`${res.msg}`, {
							theme: 'bubble',
							position: 'top-right',
							duration: 3000
						})
						if (res.statusCode == 200) {
							// this.statusSubmitForm = 'ok'
							// this.$router.push('/user-examination')
						} else {
						}
					})
					.catch((error) => {
						if (error.response) {
							console.log('log catch dispatch dari file .vue ==>', error.response.data.payload)
							let toast = this.$toasted.show(`${error.response.data.payload}`, {
								theme: 'bubble',
								position: 'top-right',
								duration: 3000
							})
						}
					})
			}

			if (this.type_examination.includes('Kesehatan Umum')) {
				let rec = this.examList.map((elem) => ({ group: elem['group'], examination_name: elem['examination_name'], unit: elem['unit'], reference_value: elem['reverence_value'], description: elem['description'], result: elem['result'], remark: this.form.remark, diagnoses: '', treatment: '', examination_purpose: this.form.examination_purpose.join(', ') }))

				this.form.records = rec
				this.$store
					.dispatch('location/createNewRecord', {
						data: this.form,
						url: 'user_examination/' + this.form.userId,
						method: this.method
					})
					.then((res) => {
						console.log(res)
						let toast = this.$toasted.show(`${res.msg}`, {
							theme: 'bubble',
							position: 'top-right',
							duration: 3000
						})
						if (res.statusCode == 200) {
							// this.statusSubmitForm = 'ok'
							// this.$router.push('/user-examination')
						} else {
						}
					})
			}

			if (this.type_examination.includes('Postpartum')) {
				this.form3.breeding = parseInt(this.form3.breeding)
				this.form3.delivery_date = this.localToUtcSameTime(this.form3.delivery_date)
				this.$store
					.dispatch('location/createNewRecord', {
						data: this.form3,
						url: 'user_pregnancies/update/' + this.form2.pregnancyId,
						method: 'PUT'
					})
					.then((res) => {
						console.log(res)
						let toast = this.$toasted.show(`${res.msg}`, {
							theme: 'bubble',
							position: 'top-right',
							duration: 3000
						})
					})
			}

			if (this.type_examination.includes('Persalinan')) {
				this.form4.pregnancyId = this.form2.pregnancyId
				this.form4.delivery_status = parseInt(this.form4.delivery_status)
				this.form4.delivery_date = this.form4.delivery_date ? this.localToUtcSameTime(this.form4.delivery_date) : ''
				this.form4.created_date = this.localToUtcSameTime(this.form4.created_date)

				this.$store
					.dispatch('location/createNewRecord', {
						data: this.form4,
						url: 'user_delivery_journals/add',
						method: 'POST'
					})
					.then((res) => {
						console.log(res)
						let toast = this.$toasted.show(`${res.msg}`, {
							theme: 'bubble',
							position: 'top-right',
							duration: 3000
						})
					})
			}

			setTimeout(() => {
				this.$router.push('/user-examination')
			}, 3000)
			// console.log(this.statusSubmitForm)
			// if (this.statusSubmitForm == 'ok') {
			// 	this.$router.push('/user-examination')
			// }
		},
		// onSubmit2() {
		// 	if (this.userId != '') {
		// 		this.method = 'PUT'
		// 	}

		// 	this.$store
		// 		.dispatch('location/createNewRecord', {
		// 			data: this.form2,
		// 			url: this.url2 + this.userId,
		// 			method: this.method
		// 		})
		// 		.then((res) => {
		// 			console.log(res)
		// 			let toast = this.$toasted.show(`${res.msg}`, {
		// 				theme: 'bubble',
		// 				position: 'top-right',
		// 				duration: 3000
		// 			})
		// 			if (res.statusCode == 200) {
		// 			} else {
		// 			}
		// 		})
		// },
		localToUtcSameTime(localString) {
			const [datePart, timePart] = localString.split('T')
			const [year, month, day] = datePart.split('-').map(Number)
			const [hour, minute] = timePart.split(':').map(Number)

			// buat tanggal "UTC" langsung, tanpa konversi zona
			const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute))
			return utcDate.toISOString()
		},
		setHPL() {
			let data = this.pregnancyList.find((o) => o.id === this.form2.pregnancyId)
			this.hpht = data.hpht
			this.hpl = data.hpl
			this.form2.pregnancy_age = String(data.usia_kehamilan_week)
		},
		setPregancy() {
			this.form.userId = this.userID.code //set USERID
			this.$store.dispatch('location/getDataPayload', {
				url: `user_pregnancies`,
				params: {
					userId: this.form.userId,
					offset: 0,
					limit: 10000,
					order: 'desc'
				}
			})
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
